/// <reference lib="webworker" />
import { PersistedClient } from '@tanstack/react-query-persist-client';
import { set } from 'idb-keyval';

import { encryptData, hashClientState } from './utils/encrypt';

declare const self: DedicatedWorkerGlobalScope;

const INDEX_DB_KEY = 'reactQuery';

self.onmessage = async ({
  data: { persistedClient, userId },
}: MessageEvent<{ persistedClient: PersistedClient; userId: number }>) => {
  try {
    const result = await encryptData(persistedClient, userId);
    const clientStateHash = await hashClientState(persistedClient);

    // Store encrypted data along with the IV and hash
    const encryptedClient = {
      ...persistedClient,
      clientStateHash,
      encryptedClientState: result?.encryptedData,
      iv: result?.iv,
      salt: result?.salt,
      clientState: undefined, // Remove plain client state before storing
    };
    await set(INDEX_DB_KEY, encryptedClient);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('Failed to persist client', error);
    }
  }
};
